export default "__VITE_PUBLIC_ASSET__e833395c__"